import { NgModule } from '@angular/core';
import { NgIconsModule, provideNgIconsConfig } from '@ng-icons/core';

import {
  hugeFolderRemove,
  hugeNotification02,
  hugeBubbleChatQuestion,
  hugeArrowDown01,
  hugeImage01,
  hugeEdit02,
  hugeSearch01,
  hugeFilter,
  hugeFolder01,
  hugeClock05,
  hugeFolderCheck,
  hugeAlert02,
  hugeCancelCircleHalfDot,
  hugePieChart,
  hugeTick01,
  hugeCalendar03,
  hugeView,
  hugeMoreVerticalCircle01,
  hugeExchange01,
  hugeAdd01,
  hugeDelete02,
  hugeTag01,
  hugeUserAdd02,
  hugeCopy01,
  hugeCheckmarkCircle04,
  hugeBubbleChat,
  hugeUserCheck01,
  hugeCancelCircle,
  hugeLogout03,
  hugeLeftToRightListBullet,
  hugeTaskDone01,
  hugeSorting01,
  hugeInformationCircle,
  hugeDownload03,
  hugeUpload03,
  hugePlusSign,
  hugeMultiplicationSign,
  hugeViewOff,
  hugeChartColumn,
  hugeMessage02,
  hugeReload,
} from '@ng-icons/huge-icons';

@NgModule({
  imports: [
    NgIconsModule.withIcons({
      hugeNotification02,
      hugeBubbleChatQuestion,
      hugeArrowDown01,
      hugeImage01,
      hugeEdit02,
      hugeSearch01,
      hugeFilter,
      hugeFolder01,
      hugeFolderRemove,
      hugeClock05,
      hugeFolderCheck,
      hugeAlert02,
      hugeCancelCircleHalfDot,
      hugePieChart,
      hugeTick01,
      hugeCalendar03,
      hugeView,
      hugeMoreVerticalCircle01,
      hugeExchange01,
      hugeAdd01,
      hugeDelete02,
      hugeTag01,
      hugeUserAdd02,
      hugeCopy01,
      hugeCheckmarkCircle04,
      hugeBubbleChat,
      hugeUserCheck01,
      hugeCancelCircle,
      hugeLogout03,
      hugeLeftToRightListBullet,
      hugeTaskDone01,
      hugeSorting01,
      hugeInformationCircle,
      hugeDownload03,
      hugeUpload03,
      hugePlusSign,
      hugeMultiplicationSign,
      hugeViewOff,
      hugeChartColumn,
      hugeMessage02,
      hugeReload,
    }),
  ],
  exports: [NgIconsModule],
  providers: [
    provideNgIconsConfig({
      size: '1.5em',
    }),
  ],
})
export class IconsModule {}
